import React, { useEffect } from "react";
import { Crown, Check, Calendar, AlertTriangle, X } from "lucide-react";

const PurohitRenewSubscription = ({ onClose, onRenew }) => {

  // Prevent background scroll
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, []);

  const benefits = [
    "Boost profile ranking for more bookings",
    "Verification badge remains active",
    "Priority listing for festivals & weekends",
    "Continue receiving customer calls & messages",
    "No break in your booking visibility",
    "Free marketing promotions on home feed",
  ];

  return (
    <div className="fixed inset-0 z-[9999] bg-black/40 backdrop-blur-sm 
                    flex justify-center items-center">

      {/* Card */}
      <div className="relative bg-white w-[90%] max-w-[420px] rounded-[28px] 
                      shadow-2xl overflow-hidden flex flex-col 
                      max-h-[90vh] overflow-y-auto">

        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 bg-white text-red-600 
                     w-9 h-9 rounded-full flex items-center justify-center 
                     shadow-md z-50"
        >
          <X size={18} />
        </button>

        {/* Header */}
        <div className="bg-gradient-to-br from-orange-500 via-orange-600 to-red-600
                        text-center pt-10 pb-14 px-6 rounded-t-[28px]">
          <div className="w-16 h-16 mx-auto bg-white/20 rounded-full 
                          flex items-center justify-center shadow-md">
            <Crown className="text-white" size={28} />
          </div>
          <h2 className="text-lg font-bold text-white mt-2">
            Renew Subscription
          </h2>
          <p className="text-white/90 text-xs mt-1">
            Keep getting premium benefits & bookings
          </p>
        </div>

        {/* Expiry Card */}
        <div className="relative -mt-8 mx-6 bg-white border border-orange-200 
                        rounded-xl p-4 shadow-md text-center">
          <div className="flex items-center justify-center text-orange-700 text-sm gap-2">
            <Calendar size={16} />
            <span><strong>Expires:</strong> 25 Jan 2025</span>
          </div>
          <p className="mt-2 text-xs text-orange-600 bg-orange-50 border border-orange-200 
                        p-2 rounded-lg flex items-center justify-center gap-1">
            <AlertTriangle size={13} />
            <strong>10 days left</strong> — Renew soon!
          </p>
        </div>

        {/* Benefits */}
        <div className="px-6 mt-5 space-y-3">
          {benefits.map((b, i) => (
            <div key={i} className="flex items-start gap-3 text-gray-700 text-xs">
              <Check size={14} className="text-green-600 mt-[2px]" />
              {b}
            </div>
          ))}
        </div>

        {/* Pricing */}
        <div className="mt-6 text-center">
          <p className="text-xs text-gray-600">Renewal Fee</p>
          <p className="text-2xl font-bold text-orange-600">
            ₹499 <span className="text-xs text-gray-500">/month</span>
          </p>
        </div>

        {/* Buttons */}
        <button
          onClick={onRenew}
          className="mt-6 mx-6 bg-gradient-to-r from-orange-600 to-red-500 py-3 
                     rounded-full text-white text-sm font-bold shadow-lg"
        >
          Proceed to Payment →
        </button>

        <button
          onClick={onClose}
          className="mt-3 mx-6 mb-6 border border-gray-300 py-2 rounded-full 
                     text-sm text-gray-600 font-medium hover:bg-gray-100"
        >
          Maybe Later
        </button>

      </div>
    </div>
  );
};

export default PurohitRenewSubscription;
